<template>
  <div>
    <!-- v-if="$store.state.userData.userId==params.data.userId" -->
    <feather-icon icon="Edit3Icon" @click="OpenB2BDiscount()" title="Düzenleme" svgClasses="h-5 w-5 mr-5 hover:text-primary cursor-pointer" />
    <feather-icon icon="Trash2Icon" @click="visible = true" title="Silme" svgClasses="h-5 w-5 mr-5  hover:text-danger cursor-pointer" />
    <vs-prompt vs-title="İskonto Sil" vs-button-cancel="border" vs-cancel-text="Vazgeç" vs-accept-text="Sil" @vs-close="cancel" @vs-cancel="cancel" @vs-accept="DeleteB2BDiscount(params.data.id)" vs-color="danger" :vs-active.sync="visible">
      <div class="vx-row ml-5 mr-5">
        <p>{{ params.data.id }} numaralı iskonto silinecektir ?</p>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
export default {
  data() {
    return {
      discountPopup: false,
      visible: false,
      products: [],
    };
  },
  name: "CellRendererActions",
  computed: {},
  beforeMount() {},
  methods: {
    OpenB2BDiscount() {
      this.params.context.componentParent.discountPopup = true;
      this.params.context.componentParent.b2bDiscountItem = this.params.data;
    },
    DeleteB2BDiscount: async function (id) {
      let r = await repository.deleteWithParam("B2B/DeleteB2BDiscount?id", id);

      if (r && r.isSuccessful) {
        await this.$swal.fire(`"${this.params.data.id}" Başarıyla Silindi.`);
        this.params.context.componentParent.getB2BDiscount();
      } else {
        this.$vs.notify({
          color: "danger",
          icon: "warning",
          title: "Hata!",
          text: `"${this.params.data.id}" silme işlemi tamamlanamadı`,
        });
      }
    },

    cancel() {
      this.visible = false;
    },
  },
};
</script>
